import React from "react";

interface VideoPlaceHolderIconProps extends React.SVGProps<SVGSVGElement> {
  size?: string;
}

export const VideoPlaceHolderIcon: React.FC<VideoPlaceHolderIconProps> = ({
  size,
  ...svgProps
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "20px"}
      height={size ?? "20px"}
      viewBox="0 0 20 20"
      fill="none"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9375 14.7917H4.375C3.33917 14.7917 2.5 13.9525 2.5 12.9167V7.08334C2.5 6.0475 3.33917 5.20834 4.375 5.20834H10.9375C11.9733 5.20834 12.8125 6.0475 12.8125 7.08334V12.9167C12.8125 13.9525 11.9733 14.7917 10.9375 14.7917Z"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8125 10.9142L15.975 13.4592C16.5883 13.9533 17.5 13.5167 17.5 12.7292V7.27083C17.5 6.48333 16.5883 6.04667 15.975 6.54083L12.8125 9.08583"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
